<template>
  <div
    class="breadcrumb container-xl mx-auto"
    style="background-color: white;"
  >
    <ul>
      <li
        v-for="(breadcrumb, idx) in breadcrumbList"
        :key="idx"
        :class="'linked'"
        @click="routeTo(idx)"
      >
        {{ idx == breadcrumbList.length - 1 ? label ? label : breadcrumb.text : breadcrumb.text }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: {
    label: {
      type: String,
      default: ''
    },
    breadcrumbOverride: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      breadcrumbList: []
    }
  },
  watch: {
    '$route' () { this.updateList() },
    breadcrumbOverride () { this.updateList() }
  },
  mounted () { this.updateList() },
  methods: {
    routeTo (pRouteTo) {
      if (this.breadcrumbList[pRouteTo].to) this.$router.push(this.breadcrumbList[pRouteTo].to)
    },
    updateList () {
      if (this.breadcrumbOverride.length > 0) {
        this.breadcrumbList = this.breadcrumbOverride
        return
      }
      this.breadcrumbList = this.$route.meta.breadCrumbs
    }
  }
}
</script>
<style scoped>
  @media (min-width: 768px) {
    ul {
      display: flex;
      justify-content: center;
      list-style-type: none;
      margin: 0;
      padding: 0;
    }
    ul > li {
      display: flex;
      float: left;
      height: 10px;
      width: auto;
      color: $default;
      font-weight: bold;
      font-size: 1em;
      cursor: default;
      align-items: center;
    }
    ul > li:not(:last-child)::after {
      content: '/';
      float: right;
      font-size: 1em;
      margin: 0 .5em;
      color: $light-default;
      cursor: default;
    }
    .linked {
      cursor: pointer;
      font-size: 1em;
      font-weight: normal;
    }
  }
  @media (max-width: 767px) {
    ul {
      display: flex;
      justify-content: center;
      list-style-type: none;
      margin: 0;
      padding: 0;
    }
    ul > li {
      display: flex;
      float: left;
      height: 10px;
      width: auto;
      color: $default;
      font-weight: bold;
      font-size: 1em;
      cursor: default;
      align-items: center;
    }
    ul > li:not(:last-child) {
      display: none;
    }
    .linked {
      cursor: pointer;
      font-size: 1em;
      font-weight: normal;
    }
  }
</style>
